import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCategories } from '../../../hooks/useCategories';
import { useAuth } from '../../../hooks/useAuth';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import SEO, { seoConfigs } from '../../common/SEO/SEO';
import SchemaOrg, { buildOrganizationSchema, buildWebSiteSchema } from '../../common/SEO/SchemaOrg';
import { Check, Trophy, Clock, Book, Phone, Rocket, Star, Zap, Banknote, Folder, SquareCheckBig, Clipboard } from "lucide-react";

import HeroSection from './Hero';
import AboutSection from './About';
import CategoriesSection from './Categories';
import StatisticsSection from './Statistics';
import StepsSection from './Steps';
import BenefitsSection from './Benefits';
import TestimonialsSection from './Testimonials';
import ContactSection from './Contact';

const HomePage = () => {
  const navigate = useNavigate();
  const { categories, loading } = useCategories();
  const { user } = useAuth();

  if (loading) {
    return <LoadingSpinner message="Cargando categorías..." />;
  }

  return (
    <>
      <SEO {...seoConfigs.home} />
      <SchemaOrg schemas={[buildOrganizationSchema(), buildWebSiteSchema()]} />
      <div className="min-h-screen bg-gray-50">
        <HeroSection navigate={navigate} />
        <CategoriesSection categories={categories} navigate={navigate} />
        <AboutSection />
        <StatisticsSection />
        <StepsSection />
        <BenefitsSection />
        <TestimonialsSection />
        <ContactSection />
      </div>
    </>
  );
};

export default HomePage;
